import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { playerApi } from "../api/player.js";
import { useStore } from "../store/useStore.js";
const STEPS = [
    {
        icon: "⚔",
        title: "3v3 Auto-Battle",
        desc: "Your 3 units fight automatically each tick. Pick the right squad — the game plays itself.",
        color: "#7c3aed",
    },
    {
        icon: "🧠",
        title: "Choose Your Strategy",
        desc: "Set an AI Preset: Balanced, Aggressive, or Defensive. Each changes how your units behave in combat.",
        color: "#f59e0b",
    },
    {
        icon: "▲",
        title: "Win → Upgrade → Climb",
        desc: "Earn Credits from every battle. Spend them to level up units. Higher stats = higher rank.",
        color: "#22c55e",
    },
];
export function OnboardingScreen() {
    const { setPlayer } = useStore();
    const [step, setStep] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const isLast = step === STEPS.length - 1;
    async function handleStart() {
        setLoading(true);
        setError(null);
        try {
            await playerApi.onboarding();
            const fresh = await playerApi.me();
            setPlayer(fresh);
        }
        catch (e) {
            setError(e.message);
            setLoading(false);
        }
    }
    return (_jsxs("div", { style: {
            display: "flex", flexDirection: "column",
            height: "100%", padding: 24,
        }, children: [_jsxs("div", { style: { textAlign: "center", paddingTop: 24, paddingBottom: 16 }, children: [_jsx("div", { style: {
                            fontSize: 52, fontWeight: 900, letterSpacing: -2,
                            background: "linear-gradient(135deg, #7c3aed, #22d3ee)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                        }, children: "xhog" }), _jsx("div", { style: { color: "#475569", fontSize: 13, marginTop: 4 }, children: "build your squad \u00B7 send it to battle" })] }), _jsxs("div", { style: { flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", gap: 24 }, children: [_jsxs("div", { style: {
                            background: "#12121a",
                            border: `1px solid ${STEPS[step].color}44`,
                            borderRadius: 20,
                            padding: 28,
                            textAlign: "center",
                            transition: "border-color 0.3s",
                        }, children: [_jsx("div", { style: {
                                    width: 72, height: 72, borderRadius: 20,
                                    background: `${STEPS[step].color}22`,
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                    fontSize: 36, margin: "0 auto 16px",
                                }, children: STEPS[step].icon }), _jsx("div", { style: { fontWeight: 800, fontSize: 18, marginBottom: 10 }, children: STEPS[step].title }), _jsx("div", { style: { color: "#94a3b8", fontSize: 14, lineHeight: 1.6 }, children: STEPS[step].desc })] }), _jsx("div", { style: { display: "flex", justifyContent: "center", gap: 8 }, children: STEPS.map((_, i) => (_jsx("div", { onClick: () => setStep(i), style: {
                                width: i === step ? 20 : 8, height: 8, borderRadius: 4,
                                background: i === step ? "#7c3aed" : "#1e293b",
                                cursor: "pointer",
                                transition: "width 0.2s, background 0.2s",
                            } }, i))) }), isLast && (_jsx("div", { style: { display: "flex", justifyContent: "center", gap: 12 }, children: [
                            { icon: "🛡", name: "Bastion", color: "#f59e0b" },
                            { icon: "⚡", name: "Raze", color: "#ef4444" },
                            { icon: "◈", name: "Null", color: "#8b5cf6" },
                            { icon: "✦", name: "Pulse", color: "#22c55e" },
                        ].map((u) => (_jsxs("div", { style: { textAlign: "center" }, children: [_jsx("div", { style: {
                                        width: 44, height: 44, borderRadius: 11,
                                        background: `${u.color}22`,
                                        border: `1px solid ${u.color}44`,
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        fontSize: 20, margin: "0 auto 4px",
                                    }, children: u.icon }), _jsx("span", { style: { fontSize: 10, color: "#475569" }, children: u.name })] }, u.name))) }))] }), _jsxs("div", { style: { paddingBottom: 16, display: "flex", flexDirection: "column", gap: 10 }, children: [error && _jsx("div", { style: { color: "#ef4444", fontSize: 13, textAlign: "center" }, children: error }), isLast ? (_jsx("button", { onClick: handleStart, disabled: loading, style: {
                            background: "linear-gradient(135deg, #7c3aed, #6d28d9)",
                            color: "#fff", border: "none", borderRadius: 14,
                            padding: "16px 0", fontSize: 16, fontWeight: 700,
                            cursor: loading ? "default" : "pointer",
                            opacity: loading ? 0.7 : 1, letterSpacing: 1,
                        }, children: loading ? "Setting up…" : "Enter the Arena →" })) : (_jsx("button", { onClick: () => setStep(s => s + 1), style: {
                            background: "#1e293b", color: "#e2e8f0",
                            border: "none", borderRadius: 14,
                            padding: "14px 0", fontSize: 15, fontWeight: 600,
                            cursor: "pointer",
                        }, children: "Next \u2192" })), !isLast && (_jsx("button", { onClick: handleStart, disabled: loading, style: {
                            background: "none", color: "#334155",
                            border: "none", fontSize: 13,
                            cursor: "pointer", padding: "4px 0",
                        }, children: loading ? "Setting up…" : "Skip tutorial" })), _jsx("div", { style: { color: "#475569", fontSize: 11, textAlign: "center" }, children: "500 credits \u00B7 20 energy \u00B7 4 units ready" })] })] }));
}
